<script>
import {
    uiState
} from '@app/store/uiStore.svelte.js'
import * as m from '@app/paraglide/messages.js';

/** @type {{currentState: boolean, toggleMenu: (menu: string) => void}} */
let { currentState, toggleMenu } = $props();

function handleToggleMenu() {
    toggleMenu('workspaces');
}

function updateLayout(layout) {
    localStorage.setItem("cc-workspace-default", layout);
    uiState.timeline = false;
    let source;
    if (player && player.src) {
        source = player.src;
    }

    uiState.layout = layout;

    setTimeout(() => {
        uiState.timeline = true;
    }, 2000);
    
    if (source && source.src) {
        player.src = '';
        setTimeout(() => {
            player.src = source;
        }, 250);
    }
}
</script>

<li class="nav-item dropdown {currentState ? 'show' : ''}" role="presentation">
    <a onclick={handleToggleMenu} 
       class="dropdown-toggle nav-link" 
       href="#!/"
       id="workspaces-menu"
       role="button"
       aria-haspopup="true"
       aria-expanded={currentState}>{m.workspaces()}</a>
    <div class="dropdown-menu {currentState ? 'show' : ''}" 
         role="menu" 
         aria-labelledby="workspaces-menu">
        <a class="dropdown-item" 
           href="#!/"
           role="menuitem"
           id="workspace-default"
           onclick={() => updateLayout('default')}>{m.workspace_default()} {#if uiState.layout === 'default'}<i class="bi bi-check-lg" aria-label={m.common_selected()}></i>{/if}</a>
        <a class="dropdown-item" 
           href="#!/"
           role="menuitem"
           id="workspace-reverse"
           onclick={() => updateLayout('reverse')}>{m.workspace_default_reverse()} {#if uiState.layout === 'reverse'}<i class="bi bi-check-lg" aria-label={m.common_selected()}></i>{/if}</a>
        <a class="dropdown-item" 
           href="#!/"
           role="menuitem"
           id="workspace-vertical"
           onclick={() => updateLayout('vertical')}>{m.workspace_vertical_stack()} {#if uiState.layout === 'vertical'}<i class="bi bi-check-lg" aria-label={m.common_selected()}></i>{/if}</a>
        <a class="dropdown-item" 
           href="#!/"
           role="menuitem"
           id="workspace-ultrawide"
           onclick={() => updateLayout('ultrawide')}>{m.workspace_ultrawide()} {#if uiState.layout === 'ultrawide'}<i class="bi bi-check-lg" aria-label={m.common_selected()}></i>{/if}</a>
    </div>
</li>
